<template>
  <div>
    <img src="@/assets/ecopoliza.jpg" class="image" />
    <h2>No más papel, ¡enviadme todo por e-mail!</h2>
    <p>
      Estamos cambiando nuestra infraestructura para evitar gastar papel
      innecesariamente y así aumentar nuestro compromiso con el cuidado del
      medio ambiente.
    </p>
    <p>
      Si quieres que a partir de ahora te envíemos cualquier tipo de
      comunicación por e-mail en vez de por correo ordinario, pulsa en el
      siguiente enlace:
      <a href="#" class="link" @click.prevent="email()"
        >Sí, enviadme cualquier comunicación por e-email
      </a>
    </p>
  </div>
</template>

<script>
export default {
  methods: {
    email() {},
  },
};
</script>

<style lang="scss" scoped>
.link {
  color: $colorMMT;
  font-weight: 460;
}
.image {
  width: 100%;
  filter: hue-rotate(100deg) brightness(90%);
}
</style>
